import { makeStyles } from 'tss-react/mui';

const RouterConfigStyles = makeStyles()(() => ({
	appWrapper: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
	},

	container: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
	},

	courseContainer: {
		paddingLeft: 0,
		display: 'flex',
		height: '100%',
	},

	minHeight: {
		minHeight: 'calc(100vh - 118px)',
	},
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default RouterConfigStyles;
